import React, { Component } from 'react';
import getContract, { getOwnerContract, getBankContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TransactionService } from '../../services/transactionService'

class Lend extends Component {

    state = {
      amount: 0,
      userId: 0,
      userAddress: "",
      isConnected: false,
      lenderEarned: 0,
      borrowers: []
    };

    constructor(props) {
      super(props);
      if(props.router.params.id) {
          this.state.userId = props.router.params.id;
      } else {
          this.state.userId = 1;
      }
      this.props.onSetUserId(this.state.userId);
    }

    getData = async () => {
      const contract = await getBankContract();

      const earnedAmountBN = await contract.lenderTotalEarned(this.state.userId);
      const lenderEarned = parseFloat(ethers.utils.formatUnits(earnedAmountBN, "mwei")).toFixed(2)

      const borrowers = await contract.getAllBorrowers();
      let borrowersArray = [];

      for (let index = 0; index < borrowers.length; index++) {
        const borrowObj = borrowers[index];
        
        const borrowerId = ethers.BigNumber.from(borrowObj["borrowerId"]).toNumber();
        const lenderId = ethers.BigNumber.from(borrowObj["lenderId"]).toNumber();
        const amount = parseFloat(ethers.utils.formatUnits(borrowObj["amount"], "mwei"));
        
        let lenderEarned = 0;
        try {
            const lenderEarnedBN = await contract.lenderEarnedAmountFromBorrower(lenderId, borrowerId);
            
            if(lenderEarnedBN.gt(0)) {
              lenderEarned = parseFloat(ethers.utils.formatUnits(lenderEarnedBN, "mwei"));
            }
        } catch (err) {
            console.error(`Error fetching lenderEarned for borrower ${borrowerId}, lender ${lenderId}:`, err);
        }
        
        let pending = (amount + 100) - lenderEarned;
        if (pending < 0) pending = 0;
    
        const time = ethers.BigNumber.from(borrowObj["time"]).toNumber();
        const date = new Date(time * 1000);
        const borrowedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
    
        let countdown = this.getCountdown(time); // Assuming getCountdown is a global function
    
        let isBorrowerInDebt = false;
        try {
            isBorrowerInDebt = await contract.isBorrowerInDebt(borrowerId);
        } catch (err) {
            console.error(`Error fetching isBorrowerInDebt for borrower ${borrowerId}:`, err);
        }
  
        if (!isBorrowerInDebt) {
          countdown = "0"
        }
  
        borrowersArray.push({ borrowerId, lenderId, amount, lenderEarned, pending, borrowedDate, countdown, isBorrowerInDebt });

        // await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 2 seconds

      }

      borrowers.forEach(async (borrowObj, index) => {
    
      });

      this.setState({ lenderEarned, borrowers: borrowersArray });
    }

    async componentDidMount() {
      // await this.connectWallet();
      const promise = this.getData();        
      
      
      await toast.promise(
        promise,
        {
          pending: 'Fetching ledger wait...',
          success: 'Ready to view!',
          error: 'Error fetching data'
        }
      )
      
    }

  getCountdown = (blockTimestamp) => {
    const startDate = new Date(blockTimestamp * 1000); // Convert seconds to milliseconds
    const targetDate = new Date(startDate.getTime() + 90 * 24 * 60 * 60 * 1000); // Add 90 days

    const now = new Date();
    const timeDiff = targetDate - now; // Remaining time in milliseconds

    if (timeDiff <= 0) {
      return "Countdown finished!";
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    return `${days} days, ${hours} hours`;
  }

  connectWallet = async () => {
      const wallet = await getWallet();
      if(!wallet.isReadOnly) {
          const browserAddresses = await wallet.provider.listAccounts();
          this.setState({ userAddress: browserAddresses[0], isConnected: true });
      } else {
          throw new Error('Wallet not connected');
      }
  }

  handleLend = async () => {
    await this.connectWallet();
    const wallet = await getWallet();
    if (!this.state.isConnected) {
      alert('Connect wallet');
      return;
    }
    try {
      var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
      const lendingPromise = transactionService.lend(this.state.amount);
      await toast.promise(
        lendingPromise,
        {
          pending: `In process`,
          success: `Successfull lended ${this.state.amount}`,
          error: 'Failed'
        }
      )
    } catch (error) {
      alert(error.message);
    }
  }

  notify = (message) => toast(message, { position: toast.POSITION.BOTTOM_CENTER});
  

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col ml-5 min-h-screen bg-main pt-20 sm:pt-14">
            <div className="flex w-full mt-5 mb-10 sm:mt-5 sm:px-5">
              <div className="flex w-full flex-wrap lg:flex-col">
                <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                  <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem" }}
                    className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                    <div className="flex justify-center">
                      <h2 className="text-white text-center text-base sm:text-sm sm:whitespace-nowrap">Lender Earned USDT</h2>
                    </div>
                    <span className="text-white text-center text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">{this.state.lenderEarned}</span>
                  </div>
                  
                  

                </div>
                
              </div>
            </div>
              <div className="flex flex-1 flex-col items-start mr-10 sm:mr-0 sm:items-stretch sm:max-w-full sm:p-5">
                <div className="flex flex-col sm:flex-1">
                  <span className="inline-block text-two-half text-white mb-2 sm:mb-7.5 sm:text-2xl">Lend Money</span>
                  <span style={{ fontSize: "18px", color: "white" }} className="inline-block text-two-half text-white mb-10 sm:mb-7.5 sm:text-3xl">Min 500 USDT - Max 2000 USDT</span>
                  <div className="flex flex-col mb-10 sm:mb-7.5">
                    <div className="w-full relative flex flex-col flex-grow-0 flex-shrink-0"><label
                      className="mb-2.5 text-white-500 sm:text-sm">Enter Amount</label>
                      <div className="w-full relative"><input style={{ background: '#303031', color: "#EF9B0F" }}
                        className="w-full bg-white-100 border-2 border-transparent rounded-mini py-3 px-5 text-white outline-none focus:border-2 focus:border-main-blue false"
                        onChange={(e) => this.setState({ amount: e.target.value })} value={this.state.amount} type="number" placeholder="500 / 1000 / 1500 / 2000" id="referralInput" /></div>
                    </div>
                  </div>
                  <div className="flex flex-col space-y-5">
                  </div>
                </div>
                <div className="flex">
                  <button style={{ background: 'white' }}
                    className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 py-5 !px-10 sm:py-5 sm:mt-7.5"
                    onClick={this.handleLend} id="nextButton" >Lend </button>
                </div>
              </div>

              <div className="mt-10 flex overflow-hidden relative w-full flex-col bg-gray-800 rounded p-7.5 pb-5 sm:p-5 sm:pl-2.5 sm:pr-2.5 sm:rounded-none">
                  <div style={{fontSize: "20px"}} className='text-center font-bold '>
                    Ledger
                  </div>
                  <div className="mt-5 sm:rounded-none z-10 flex flex-1 flex-col w-full flex-col rounded overflow-hidden h-full min-h-90 sm:max-h-3/4">
                    <div className="overflow-auto">
                      <table className="min-w-max w-full table-auto border-white-100">
                        <thead>
                          <tr className="text-white text-xs border-b border-white-100">
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-left font-normal sm:p-3 "
                            >
                              Borrower Id
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-left font-normal sm:p-3"
                            >
                              Lender Id
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Amount
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Got back
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Pending
                            </th>

                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Borrowed Date
                            </th>

                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Countdown
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className=" text-sm font-light align-baseline">
                          {this.state.borrowers.map((data, index) => {
                            return (<tr
                              style={{ border: "1px solid" }}
                              key={index}
                              className="border-b border-blue-100 last:border-none mt-1"
                            >
                              <td className=" p-3 text-center whitespace-nowrap sm:p-3">
                                <div
                                  style={{ fontSize: "15px" }}
                                  className="text-sm "
                                >
                                 {data.borrowerId}
                                </div>
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-center whitespace-nowrap sm:p-3"
                              >
                                {data.lenderId}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                {data.amount}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                {data.lenderEarned}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                {data.pending}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                {data.borrowedDate}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                {data.countdown}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                {data.isBorrowerInDebt ? "On going": "Closed"}
                              </td>
                            </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
 
export default withWrapper(Lend);